/**
 * useReducedMotion — Track the user's `prefers-reduced-motion` preference.
 *
 * Returns `true` when the OS-level accessibility setting requests
 * reduced motion. Demos should consult this before scheduling auto-
 * play loops, intensive transitions, or particle effects, and should
 * fall back to a single static frame when it is set.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import { useMediaQuery } from "./useMediaQuery.js";

export function useReducedMotion(): boolean {
  return useMediaQuery("(prefers-reduced-motion: reduce)");
}
